import React from "react";

import { Container } from "./styles";

const Contact = ({ id }: any) => {
  return <Container id={id}>antonio.lelis@acel.com.br</Container>;
};

export default Contact;
